import React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import __ from "src/utils/Translations";
import PageTitle from "src/Layout/AppMain/PageTitle";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import { useGetTotalRewardsConfigs } from "src/Pages/Company/TotalReward/api/useConfigs";
import PerksListing from "src/Pages/Company/TotalReward/Perks/PerksListing";

export default () => {
  const companyName = useCompanyName();
  const companyId = useCompanyId();
  const pathPrefix = `/ahr`;

  const { getConfigValue } = useGetTotalRewardsConfigs(companyId);

  return (
    <CSSTransitionGroup
      component="div"
      transitionName="TabsAnimation"
      transitionAppear
      transitionAppearTimeout={0}
      transitionEnter={false}
      transitionLeave={false}
    >
      <PageTitle
        heading={`${__(
          "Zarządzanie benefitami dla firmy"
        )} ${companyName} (ID: ${companyId})`}
        breadcrumbsHeading={__("Zarządzanie benefitami")}
        pushToHistory
        breadcrumbs={[
          {
            title: "Total Reward Statement",
            link: `${pathPrefix}/total-reward`,
          },
        ]}
      />
      <PerksListing
        pathPrefix={pathPrefix}
        availableBenefitsEnabled={getConfigValue(
          "available_benefits_module",
          false
        )}
        yourBenefitsEnabled={getConfigValue("your_benefits_module", false)}
      />
    </CSSTransitionGroup>
  );
};
